module.exports = ".btn-block {\n  width: 100% !important; }\n\n.text-justify-centre {\n  -webkit-box-pack: centre !important;\n      -ms-flex-pack: centre !important;\n          justify-content: centre !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-login-widget/logoutredirect/logoutredirect.component.scss
// module id = ./src/app/new-login-widget/logoutredirect/logoutredirect.component.scss
// module chunks = main